import { Client } from "@/Common/Api/Client";
import { ErrorMessage } from "@/Common/Api/Dto/ErrorMessage";
import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { SpanControl } from "@/Common/Components/SpanControl";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { ResourceProvider } from "@/Common/Resources/StaticResources";
import { FacturationNetCredentialsPopup as MyleResoucesForFacturationNetCredentialsPopup } from "@/Common/Resources/StaticResourcesFor";
import { ServerEvent } from "@/Common/Stores/Actions/ServerEvent";

interface IFacturationNetCredentialsPopupProps {
    response: ServerEvent;
    onCloseCallback: () => void;
}

class FacturationNetCredentialsPopupState {
    public username: string;
    public password: string;
    public errors: ErrorMessage[];
    public previousOperation: number;
    public badUsername: string;
    public isValidUsername: boolean;
}

class FacturationNetCredentialsPopup extends BaseReactComponent<IFacturationNetCredentialsPopupProps, FacturationNetCredentialsPopupState> {
    private stringProvider: ResourceProvider;

    public componentWillMount(): void {
        this.stringProvider = new ResourceProvider(new MyleResoucesForFacturationNetCredentialsPopup, sessionStore.locale);

        this.mutateState(
            s => {
                s.username = "";
                s.password = "";
                s.previousOperation = this.props.response.Operation;
                s.errors = [];
                s.badUsername = "";
                s.isValidUsername = false;
            },
            () => this.updateStateFromResponse(this.props.response.Data, this.props.response.Errors)
        );
    }

    public updateStateFromResponse(responseData: { Username: string }, responseErrors: ErrorMessage[]): void {
        let errors = responseErrors != null ? responseErrors : [];
        this.mutateState(s => {
            s.username = responseData.Username;
            s.errors = errors;
            s.badUsername = errors.some(x => x.Code == "CannotAccessPhysician") ? responseData.Username : null;
            s.isValidUsername = this.isUsernameValid(s.username, s.badUsername);
        });
    }

    public render(): JSX.Element {
        return (
            <div className="dsq-nip-popup auto" onKeyDown={e => this.handleKeyDown(e)}>
                <div className="dsn-header p-header">
                    <span>Facturation Net Credentials</span>
                </div>

                <div className="dsn-main">
                    <div>
                        <span>{this.stringProvider.GetString("username")}</span>
                        <TextboxControl
                            noAutoCompleteStyle={{ paddingRight: "20px" }}
                            value={this.state.username}
                            onChange={text => this.handleUsernameChanged(text)}
                            valid={this.state.isValidUsername}
                        />
                    </div>
                    <div style={{ marginTop: "10px", paddingRight: "20px" }}>
                        <span>{cacheStore.GetString("PasswordLabel")}</span>
                        <input
                            className="form-control"
                            type="password"
                            onChange={(e: any) => this.handlePasswordChanged(e.target.value)}
                            value={this.state.password}
                            autoComplete="off"
                        />
                    </div>
                    <div style={{ marginTop: "10px" }}>
                        {this.state.errors
                            .filter(error => !IsNullOrWhiteSpace(error.Message))
                            .map((error, index) => {
                                let cannotAccessPhysician = error.Code == "CannotAccessPhysician";
                                let message = error.Message;
                                if (cannotAccessPhysician)
                                    message = message + " (" + sessionStore.getCurrentEmployee().Model.FirstLicenceNumber + ")";

                                return (
                                    <div key={`${error.Code} ${error.Message} ${index}`}><SpanControl IsRed={true} text={message} /></div>
                                );
                            })}

                    </div>
                </div>

                <div className="dsn-footer" style={{ "marginTop": "10px" }}>
                    <div className="flex-container" style={{ "justifyContent": "flex-end" }}>
                        <button
                            className="btn btn-default push-right-5"
                            onClick={() => this.props.onCloseCallback()}
                        >
                            {cacheStore.GetString("CancelLabel")}
                        </button>
                        <button
                            className="btn btn-primary"
                            disabled={IsNullOrWhiteSpace(this.state.username) || IsNullOrWhiteSpace(this.state.password) || !this.state.isValidUsername}
                            onClick={() => this.handleSubmit()}
                        >
                            {cacheStore.GetString("SaveLabel")}
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    private handleUsernameChanged(text: string): void {
        this.mutateState(s => {
            s.username = text;
            s.isValidUsername = this.isUsernameValid(text, s.badUsername);
        });
    }

    private handlePasswordChanged(text: string): void {
        this.mutateState(s => s.password = text);
    }

    private handleKeyDown(e: React.KeyboardEvent): void {
        // enter
        if (e.keyCode === 13)
            this.handleSubmit();

        // escape
        if (e.keyCode === 27 && this.props.onCloseCallback)
            this.props.onCloseCallback();
    }

    public isUsernameValid(typedUsername: string, badUsername: string): boolean {
        const mustChangeUsername = !IsNullOrUndefined(badUsername) && badUsername == typedUsername;

        return !IsNullOrUndefined(typedUsername) && !mustChangeUsername;
    }

    private handleSubmit(): void {
        Client.Post(
            ServerOperations.Server.FacturationNetClient_UpdateFacturationNetUser,
            {
                Username: this.state.username,
                Password: this.state.password
            },
            response => {
                if (response.Success && this.props.onCloseCallback) {
                    this.props.onCloseCallback();
                    return;
                }

                this.updateStateFromResponse(response, response.Errors);
            }
        );
    }
}

export { FacturationNetCredentialsPopup };
